import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import RescheduleRequestStyle from "@/styles/components/reschedule-request-modal/_index.module.scss";
import Button from "@/components/button";
import "react-datetime/css/react-datetime.css";
import Exclamation from 'public/new-icons/info-icon.svg';
import { Field, FieldArray, Form, FormStyle, Formik, FormikControl, InputError, useTranslation } from '@/imports-files/common/common';
import { Page, useState, rescheduleInerview, checkAvailability, acceptSlot, Image } from "@/imports-files/pages/clients/jobs/candidate-profile-job";
import {Yup, TRANSLATION, todayDate, tomorrowDate} from '@/imports-files/pages/interviews/cronofy';
import moment from 'moment';
import { setFilledDate } from "@/imports-files/components/job-filters";
import { FormModalStyle } from "@/imports-files/components/common-modal/common-modal";
import Modal from "@/components/common-modal/modal";

export function RescheduleRequest({setBtnPopup, router, request, meetingDetails, meetingId, setInitialData, setShowLoader, setFlagForRender}) 
{
  const {t} = useTranslation()
  const meeting_preference                      =     meetingDetails.details
	const heading                                 =     meetingDetails.status   ==  'pending' ? t('modal:form:reschedule:request_more_slots') :  t('modal:form:reschedule:reschedule_interview')
  const [no_of_slots, setNoOfSlots]             =     useState(0)
  const [submitState, setSubmitState ]          =     useState('check_availability');
  const showNewDates                            =     request == 'reschedule' ? '' : 'dnone'
  const moreSlotsSection                        =     request == 'reschedule' ? 'dnone' : ''
  const initialValues                           =     {
                                                        start_date: '',
                                                        end_date: ''
                                                      }

  function validationSchema(t){
    let a = {
      start_date: Yup.string().required(TRANSLATION('errors:required')),
      end_date: Yup.string().when("start_date", {
        is: () => { return true },
        then: Yup.string().required(TRANSLATION('errors:required')).test("is-greater", TRANSLATION('errors:end_date_invalid'), function(value) {
          let start_date = this.parent.start_date
          return moment(value, "DD:MM:YYYY").isSameOrAfter(moment(start_date, "DD:MM:YYYY"))
        })
      })
    }
    const RECHEDULE_REQUEST = Yup.object().shape(a)
    return RECHEDULE_REQUEST
}

  function requestNewSlots(){
    document.querySelector('.new-dates-section').classList.remove('dnone');
  }

  function noOfSlotsClass(no_of_slots){
    return no_of_slots > 0 ? PageStyle.RequestDetails__AvailableSlotsBg   : PageStyle.RequestDetails__NoAvailableSlotsBg
  }

  return (
    <Modal
    type="form"
    heading = {heading}
    closeModal={(event) => {
     setBtnPopup(false)
    }}
    content={
      <div className={`RequestMore`}>
        {meeting_preference && <div className= {`${PageStyle.RequestDetails} ${moreSlotsSection}`}>
           <h4>{t('modal:form:reschedule:heading')}:</h4>

           <h5>{t('modal:form:reschedule:subheading')}: <span>{meeting_preference.preferred_date_time}</span></h5>

           <h5>{t('modal:form:reschedule:message')}: <span>{meeting_preference.reason}</span></h5>
           {meeting_preference.can_accept ?  <p><Exclamation/> {t('modal:form:reschedule:slot_available')}</p> : <p><Exclamation/> {t('modal:form:reschedule:slot_not_available')}.</p>}
           <div className={`textcenter mt20`}>
            <div className={PageStyle.SetupPopup__RequestAccessBtn}>
             <Button buttonstyle={`${PageStyle.primarybtn}`} type="button" onClick={async()=> {
              await acceptSlot(meetingId, meeting_preference.id, setBtnPopup, router, setInitialData,setShowLoader);
             }}>{t('modal:form:reschedule:accept_request')}</Button>

             <Button buttonstyle={`${PageStyle.secondarybtn}`} type="button" onClick={()=> requestNewSlots()}>{t('modal:form:reschedule:suggest_new_slots')}</Button>
           </div></div>
          </div> }
          <div className={`RequestDetails ${PageStyle.RequestDetails} ${showNewDates} new-dates-section`}>
            <h4>{t('modal:form:reschedule:suggest')}:</h4>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema(t)}
              onSubmit={
                async (values) => {
                  if(submitState == 'submit')
                    await rescheduleInerview(values, meetingId, setBtnPopup, router, setInitialData)
                  else
                    await checkAvailability(values, meetingId, router, setNoOfSlots)
                }
              }>
              {(formik) => (
                <Form>
                 <label className={`${PageStyle.ClientCompany__BodyText} mb0`}>{t('modal:form:reschedule:preferred_dates')}:</label>
                 <div className={`${PageStyle.RequestDetails__ContentBlock} ${RescheduleRequestStyle.RescheduleRequest__ContentBlock} mt10`}>
                    <FormikControl
                      control                 =   "customDatePicker"
                      className               =   {`${RescheduleRequestStyle.RescheduleRequest__JobCustomDateTime}`}
                      format                  =   {"DD/MM/YYYY"}
                      inputProps              =   {{
                                                      placeholder: t('placeholder:start_date'),
                                                      readOnly: true,
                                                      style: InputError(formik, 'start_date'),
                                                  }}
                      formik                  =   {formik}
                      name                    =   {'start_date'}
                      disablePast             =   { true }
                      minDate                 =   { new Date(new Date().setDate(new Date().getDate()+1)) }
                      onChange                =   {(moment) => {
                                                                    formik.setFieldValue('start_date',moment.format('DD/MM/YYYY'));
                                                                }}
                      style                   =   {InputError(formik, 'start_date')}
                      value                   =   { typeof formik.values.start_date == 'string' ? setFilledDate(formik.values.start_date) : formik.values.start_date}
                    />

                    <FormikControl
                      control                       =   "customDatePicker"
                      className                     =   {`${RescheduleRequestStyle.RescheduleRequest__JobCustomDateTime}`}
                      format                        =   {"DD/MM/YYYY"}
                      inputProps                    =   {{
                                                            placeholder: t('placeholder:end_date'),
                                                            readOnly: true,
                                                            style:   InputError(formik, 'end_date'),
                                                        }}
                      formik                        =   {formik}
                      name                          =   {'end_date'}
                      onChange                      =   {(moment) => {
                                                                        formik.setFieldValue('end_date',moment.format('DD/MM/YYYY'));
                                                                    }}
                      style                         =   {InputError(formik, 'end_date')}
                      disablePast                   =   { true }
                      minDate                       =   { new Date(new Date().setDate(new Date().getDate()+1)) }
                      value                         =   { typeof formik.values.end_date == 'string' ? setFilledDate(formik.values.end_date) : formik.values.end_date}
                    />

                    <Button buttonstyle={`${PageStyle.primarybtn} ${RescheduleRequestStyle.RescheduleRequest__primarybtn}`} type="button" onClick={async()=> {
                      await setSubmitState('check_availability')
                      formik.submitForm()
                    }} >{t('modal:form:reschedule:check_availability')}</Button>
                  </div>

                  <div className={`mb20 ${PageStyle.RequestDetails__SlotsAvailablity} ${RescheduleRequestStyle.RescheduleRequest__SlotsAvailablity} `}>
                    <span className={`${noOfSlotsClass(no_of_slots)}`}>{no_of_slots}&nbsp;{t('modal:form:reschedule:slots_available')}</span>
                  </div>
                  <div className={`${PageStyle.SetupPopup__Footer} ${RescheduleRequestStyle.RescheduleRequest__Footer}`}>
                  <div className={`textcenter`}>
                    <Button buttonstyle={`${PageStyle.secondarybtnborder}`} type="button" onClick={async ()=>{
                      await setSubmitState('submit');
                      formik.submitForm();
                    }} disabled={!(no_of_slots > 0)}>{t('modal:form:reschedule:send_invite')}</Button>
                  </div>
                  </div>
                </Form>
              )
              }
            </Formik>
              </div>
      </div>
    }
    />
  )

}
